import { Component, OnInit } from '@angular/core';
import {  Location } from '@angular/common';
import { HttpService } from 'src/service/http.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-scan-qr',
  templateUrl: './scan-qr.component.html',
  styleUrls: ['./scan-qr.component.css']
})
export class ScanQrComponent implements OnInit {
  searchTexts:any;
  timeout: any = null;
  samplesList: any;

  constructor(private location: Location , private httpService: HttpService) { }

  ngOnInit(): void {
    const userId = localStorage.getItem('uuid');

    const sampleObj = [
      {
        "_methodName": "17",
        "_userId": userId
      }
    ]

    this.httpService.SMPL_TESTING_LIST(sampleObj).subscribe(data => {
     // console.log(data);

      const samplesReceivedData = JSON.parse(localStorage.getItem('samplesReceivedData'));

      this.samplesList = data.responseData[2]


    });
  }
  backButton() {
    this.location.back()
  }

  onKeySearch(event: any) {
   // console.log(event.target.value)
    const pattern = /^((http|https|ftp):\/\/)/;
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.keyCode != 13 && event.target.value != '') {
        $this.executeListing(event.target.value);
      }
      if(event.target.value === ''){
        this.searchTexts = ''
      }
    }, 1000);
  }

   executeListing(value: string) {
   //  console.log(value)
    const userId = localStorage.getItem('uuid');

    const decryptObject = {
      "_userId": userId,
      "_siToken":value
    }
  this.httpService.DecryptQR(decryptObject).subscribe(result=>{

    this.searchTexts =  result.responseData['_sysSampleId'];

    // forEach(element => {
    //   if(element.tray_seq === result.responseData['_sysSampleId']){
    //     this.searchTexts = 
    //   }
    // });
 const count = this.samplesList.filter(sample=> sample.sysSampleId === parseInt(result.responseData['_sysSampleId']))
        
 // console.log(count.length);
  if(count && count.length === 1){
this.searchTexts = count[0].tray_seq;
  } else{
    
  }
    

  });

   
  }
  submit(){
    Swal.fire({
      title: `Sample ID ${this.searchTexts} Assigned`,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        container: 'my-swal-two',
        confirmButton: 'your-confirm-button-class-one',
        cancelButton: 'your-cancel-button-class-one',

      }
    }).then((result) => {
      if(result.value){
        this.location.back();
      }
    
    });
  }
  cancel(){
    this.location.back();

  }
}
